import CarrotClient from "../../../lib/carrot-api"
import Settings from "../../../utils/CarrotConfig"
import { useQuery, UseQueryResult } from "react-query"
import ResponseError from "../../../utils/ResponseError"
import { RetryConfig } from "utils/ErrorHandling"
import { CarrotPlan } from "types/CarrotPlan"
const client = new CarrotClient(Settings.CARROT_BACKEND_URL)
const ENDPOINT = "GetCarrotPlan"

export default function useCarrotPlan(carrotPlanId): UseQueryResult<CarrotPlan, ResponseError> {
  return useQuery<CarrotPlan, ResponseError>([ENDPOINT, carrotPlanId], () => client.getCarrotPlan(carrotPlanId), {
    ...RetryConfig
  })
}
